// Easter egg logo (M-3): jednorazowy wystrzał konfetti w 4 kolorach marki z pozycji logo.
// Kolory adaptują się do motywu (dark: jasne pastele; light: głębsze, nasycone). ~1.2 s.
// Warstwa nie przyjmuje kliknięć. Przy prefers-reduced-motion nic się nie dzieje (A-6).

const BRAND_DARK = ["#67e8f9", "#c084fc", "#fda4af", "#a3e635"]; // pastele marki
const BRAND_LIGHT = ["#0891b2", "#7c3aed", "#db2777", "#65a30d"]; // głębsze, nasycone

export function fireLogoConfetti(origin: { x: number; y: number }) {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  const isDark = document.documentElement.getAttribute("data-theme") === "dark";
  const colors = isDark ? BRAND_DARK : BRAND_LIGHT;

  const layer = document.createElement("div");
  layer.style.cssText =
    "position:fixed;inset:0;pointer-events:none;z-index:70;overflow:hidden;";
  document.body.appendChild(layer);

  const COUNT = 44;
  const pieces: {
    el: HTMLDivElement;
    x: number;
    y: number;
    vx: number;
    vy: number;
    rot: number;
    vr: number;
  }[] = [];

  for (let i = 0; i < COUNT; i++) {
    const el = document.createElement("div");
    const size = 7 + Math.floor(i % 5);
    el.style.cssText = `position:absolute;width:${size}px;height:${size * 1.6}px;border-radius:1px;background:${colors[i % colors.length]};will-change:transform,opacity;`;
    layer.appendChild(el);
    const angle = Math.random() * Math.PI * 2;
    const speed = 6 + Math.random() * 9;
    pieces.push({
      el,
      x: origin.x,
      y: origin.y,
      vx: Math.cos(angle) * speed,
      vy: Math.sin(angle) * speed - 4,
      rot: Math.random() * 360,
      vr: (Math.random() - 0.5) * 24,
    });
  }

  const start = performance.now();
  const DURATION = 1300;

  function frame(now: number) {
    const t = now - start;
    const life = t / DURATION;
    for (const p of pieces) {
      p.vy += 0.55; // grawitacja
      p.vx *= 0.99;
      p.x += p.vx;
      p.y += p.vy;
      p.rot += p.vr;
      p.el.style.transform = `translate(${p.x}px, ${p.y}px) rotate(${p.rot}deg)`;
      // Kryjące przez większość życia, szybki zanik na końcu (nie "brudny" wygląd).
      p.el.style.opacity = life > 0.75 ? String(Math.max(0, (1 - life) / 0.25)) : "1";
    }
    if (t < DURATION) {
      requestAnimationFrame(frame);
    } else {
      layer.remove();
    }
  }
  requestAnimationFrame(frame);
}
